/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";

import { useApi } from "@/hooks/useApi";
import { useAuth } from "@/modules/auth";
import { getRuntimeConfig } from "@/config/runtimeConfig";
import { PKCE_STATE_KEY, PKCE_VERIFIER_KEY } from "@/modules/auth/core/pkce";

export function AuthorizeLogin() {
	const [searchParams] = useSearchParams();
	const [error, setError] = useState<string | null>(null);
	// StrictMode roda o efeito duas vezes em dev — sem essa guarda, a segunda
	// chamada acha o sessionStorage já limpo pela primeira e mostra erro por
	// um instante, mesmo com o login concluindo com sucesso logo em seguida.
	const startedRef = useRef(false);

	const { saveAuth, currentAuth } = useAuth();
	const navigate = useNavigate();
	const { api } = useApi();

	const { authorizationCodeGrantClientId, authorizeRedirectUri } = getRuntimeConfig();

	async function handleNewToken() {
		// O code_verifier nunca viaja pela URL — só o /sso/start (que o gerou)
		// tem acesso a ele, via sessionStorage. "state" volta a ser um nonce
		// anti-CSRF de verdade, comparado contra o valor salvo antes do redirect.
		const expectedState = sessionStorage.getItem(PKCE_STATE_KEY);
		const codeVerifier = sessionStorage.getItem(PKCE_VERIFIER_KEY);
		sessionStorage.removeItem(PKCE_STATE_KEY);
		sessionStorage.removeItem(PKCE_VERIFIER_KEY);

		if (!expectedState || !codeVerifier || searchParams.get("state") !== expectedState) {
			setError("Sessão de login inválida ou expirada. Volte e tente novamente.");
			return;
		}

		try {
			const response = await api.post("/oauth/token", {
				grant_type: "authorization_code",
				client_id: authorizationCodeGrantClientId,
				redirect_uri: authorizeRedirectUri,
				code: searchParams.get("code"),
				code_verifier: codeVerifier,
			});

			const data = response.data;

			if (data) {
				data.issued_by_client_id = authorizationCodeGrantClientId;
				saveAuth(data);
			}
		} catch (error: any) {
			console.error(error);
			setError("Não foi possível concluir o login. Tente novamente.");
		}
	}

	useEffect(() => {
		if (currentAuth) {
			navigate("/");
			return;
		}

		if (startedRef.current) {
			return;
		}
		startedRef.current = true;

		handleNewToken();
	}, [currentAuth]);

	if (error) {
		return (
			<div id="splash-screen" className="splash-screen">
				<span className="mt-3">{error}</span>
			</div>
		);
	}

	return (
		<div id="splash-screen" className="splash-screen">
			<Spinner animation="border" variant="primary" />
			<span className="mt-3">Carregando...</span>
		</div>
	);
}
